module.exports = "query refreshTwilioToken($user:String!){refreshTwilioToken(user:$user)}"